<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          TapTags & TapIt.kr
        </h1>
        <h2>Featured Event:</h2>
        <h2>진행 중 이벤트:</h2>
        <v-img
          src="https://s3.ap-northeast-2.amazonaws.com/thedropboxkr.x2o.net/ABX2025/ABX2025Square.png"
          class="my-3"
          max-height="250"
          contain
        ></v-img>
        <p class="subheading font-weight-regular">
          Please Login/Register to sign up for your event.
          <br />
          이벤트 등록을 위해 로그인/회원가입을 진행해주세요.
          <br />
          <v-btn to="/profile/login"> Login </v-btn>
          <v-btn to="/profile/register" color="primary"> Register </v-btn>
        </p>
      </v-flex>
      <v-flex xs12 mb-5>
        <h2 class="headline font-weight-bold mb-3">Important Links</h2>

        <v-layout justify-center>
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </v-layout>
        <br />
        <h2 class="headline font-weight-bold mb-3">Need Help?</h2>
        Having trouble or need help? Email 주소 daltotheworld@gmail.com
      </v-flex>

      <!--
      <v-flex
        mb-5
        xs12
      >
        <h2 class="headline font-weight-bold mb-3">What's next?</h2>

        <v-layout justify-center>
          <a
            v-for="(next, i) in whatsNext"
            :key="i"
            :href="next.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ next.text }}
          </a>
        </v-layout>
      </v-flex>
      <v-flex
        xs12
        mb-5
      >
        <h2 class="headline font-weight-bold mb-3">Ecosystem</h2>

        <v-layout justify-center>
          <a
            v-for="(eco, i) in ecosystem"
            :key="i"
            :href="eco.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ eco.text }}
          </a>
        </v-layout>
      </v-flex>
  -->
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    ecosystem: [],
    importantLinks: [
      {
        text: 'ABX 2025 Home Page',
        href: 'https://asiabalboa.com/',
      },
    ],
    whatsNext: [
      {
        text: 'Explore components',
        href: 'https://vuetifyjs.com/components/api-explorer',
      },
      {
        text: 'Select a layout',
        href: 'https://vuetifyjs.com/layout/pre-defined',
      },
      {
        text: 'Frequently Asked Questions',
        href:
          'https://vuetifyjs.com/getting-started/frequently-asked-questions',
      },
    ],
  }),
};
</script>

<style></style>
